export const isValidLeadTimeDays = (days: string | number | null | undefined): boolean => {
  if (days === null || days === undefined || days === "") return false;
  const value = Number(days);
  return Number.isInteger(value) && value > 0;
};